import React, { useEffect } from 'react';
import './styles.css';
import P from 'prop-types';
import { toast } from 'react-toastify';

export const SacolaMenuEdicao = ({ param }) => {
  const editar = () => {
    param.onEdit();
  };

  const excluir = () => {
    param.onDelete(param.item);
    toast.error('Item removido da sacola');
  };

  useEffect(() => {
    document.getElementById('top').style.zIndex = '90';
    document.getElementById('categorias').style.zIndex = '90';
    return () => {
      document.getElementById('top').style.zIndex = '999';
      document.getElementById('categorias').style.zIndex = '999';
    };
  }, []);

  return (
    <div>
      {param.item.tipo_produto != 'PIZZA' && (
        <div className="sacola-menu-opcoes" onClick={() => editar()}>
          Editar
        </div>
      )}
      <div className="sacola-menu-opcoes" onClick={() => excluir()}>
        Excluir
      </div>
    </div>
  );
};

SacolaMenuEdicao.propTypes = {
  param: P.object,
};
